import React, { useEffect, useState } from 'react';
import { useIsMobile } from 'hooks/useIsMobile';
import { useLogin } from 'pages/Header/Content/hooks/useLogin'
import './style.sass';

import { decodeStorage, encodeStorage, removeStorage } from 'functions/storageBase64';
import { SHA1 } from 'functions/generateSHA1'
import { SSO } from 'pages/Header/Content/constants/general'


import { Header } from 'pages/Header'
import ErrorType from 'pages/Error/ErrorType';

import LoginForm from 'components/LoginRegistro/Login';
import Loading from 'components/Loading';
import { ErrorBoundary } from 'components/Error/ErrorBoundary'

import { DireccionIncode } from 'pages/NuevoCredito/Incode/UltimosPasosCredito/DireccionIncode';
import { DatosRecabadosIncode } from 'pages/NuevoCredito/Incode/DatosRecabados/datosRecabadosIncode';
import { LineaTelmex } from 'pages/NuevoCredito/LineaTelmex/lineaTelmex';
import { ConLineaTelmex } from 'pages/NuevoCredito/ConLineaTelmex/conLineaTelmex';
import { InformacionPersonalMobile } from 'pages/Credito/10-SolicitarTarjeta/informacionPersonalMobile';
import { OcupacionIncode } from 'pages/NuevoCredito/Incode/UltimosPasosCredito/OcupacionIncode';
import { IngresoMensuelIncode } from 'pages/NuevoCredito/Incode/UltimosPasosCredito/IngresoMensual';
import ComenzarIncodeIndex from 'pages/NuevoCredito/Incode/ComenzarIncode';
import { RedirigirMovil } from 'pages/NuevoCredito/Incode/RedirigirMovil/redirigirMovil';


export default function Login() {

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Login Page');
        removeStorage('tokenOTP')
        window.scrollTo(0, 0);
    }, [])

    const { isMobile } = useIsMobile();

    useEffect(() => {
        if (isMobile) {
            if (isMobile === 'desktop') {
                document.querySelector('#root').classList.add('desktopView')
            }
            else{
                document.querySelector('#root').classList.add('loginHeaderMobile')
            }
        }
    }, [isMobile])

    return (
        <>
            <ErrorBoundary>
                <Header type='simple' pageClass="loginHeader" />
            </ErrorBoundary>

            {SSO
                ? SSO.active
                    ? <LoginSSO />
                    : <LoginOld isMobile={isMobile} />
                : <LoginOld isMobile={isMobile} />
            }
        </>
    )
}

export function LoginSSO() {

    const isLoged = decodeStorage('session_token');
    const dateActual = new Date()
    const rand = Math.random()
    const [loading, setLoading] = useState(true)

    const redirURL =  encodeURIComponent(`${window.location.origin}/credito-claroshop/authenticated`)
    const redirectURL = encodeURIComponent( window.location.href.split('?redirect=')[1] )

    useEffect(() => {
        
        if(redirectURL != "undefined" && redirectURL != null){
            encodeStorage('redirectURL', redirectURL)
        }else{
            removeStorage('redirectURL')
        }

        if(!isLoged){
            let state = SHA1(rand+'|'+dateActual)
            let nonce = SHA1((rand * 2) +'|'+dateActual)
            encodeStorage('stateSSO', state)
            encodeStorage('nonceSSO', nonce )
            window.location.replace(`${SSO.ssoURL}/realms/${SSO.realmSSO}/protocol/openid-connect/auth?client_id=${SSO.clientSSO}&redirect_uri=${redirURL}&state=${state}&response_mode=fragment&response_type=code&scope=openid&nonce=${nonce}`)
        }else{
            let redirectURL = decodeStorage('redirectURL')
            if(redirectURL){
                window.location.replace( decodeURIComponent( redirectURL ) )
            }else{
                window.location.replace( window.location.origin )
            }
        }

    },[])

    return(
        <>
            { loading && 
                <ErrorBoundary>
                    <Loading />
                </ErrorBoundary>  
            }
            <main>
                <p></p>
            </main>
        </>
        
    )

}


export function LoginOld(props) {
    const {
        isMobile
    } = props

    const {
        dataLogin,
        reciveDataLogin,
        reciveDataFacebook
    } = useLogin()

    return (
        <>
            { dataLogin.loading && 
                <ErrorBoundary>
                    <Loading />
                </ErrorBoundary>  
            }
            <main>
                {dataLogin.statusCode !== 500
                    ?
                        <>
                            {!dataLogin.isLoged &&
                                <section className="loginRegistroPage">
                                    <div className="container">
                                        <h1 className="strong">Bienvenido</h1>
                                        <ErrorBoundary>
                                            <LoginForm
                                                dataForm={reciveDataLogin}
                                                warningMessage={dataLogin.errorMessage}
                                                urlRedirect={dataLogin.redir}
                                                responseFacebook={reciveDataFacebook}
                                                isMobile={isMobile}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                </section>
                            }
                        </>
                    :
                        <>
                            <ErrorBoundary>
                                <ErrorType
                                    codeStatus={500}
                                    errorText={""}
                                />
                            </ErrorBoundary>
                        </>
                }
            </main>
        </>
    )
}










// export default function Login() {

//     //- Codigo de instana para track de pagina 
//     // useEffect(() => {
//     //     window.ineum('page', 'Login Page');
//     //     window.scrollTo(0, 0);
//     // }, [])

//     const {
//         dataLogin,
//         reciveDataLogin,
//         reciveDataFacebook
//     } = useLogin()


//     const { isMobile } = useIsMobile();
//     //const desktopView = () => document.querySelector('#root').classList.add('desktopView')
//     useEffect(() => {
//         if (isMobile) {
//             if (isMobile === 'desktop') {
//                 document.querySelector('#root').classList.add('desktopView')
//             }
//             else{
//                 document.querySelector('#root').classList.add('loginHeaderMobile')
//             }
//         }
//     }, [isMobile])

//     //<ComenzarIncodeIndex />,<DireccionIncode />, <DatosRecabadosIncode />
//     //<ConLineaTelmex />, <InformacionPersonalMobile />, <IngresoMensuelIncode />

//     return (
//         <>
//             { dataLogin.loading && <Loading />}
//             <Header type='simple' pageClass="loginHeader" />
//             <main>
//                 {dataLogin.statusCode !== 500
//                     ?
//                         <>
//                             {!dataLogin.isLoged &&
//                                 <section className="loginRegistroPage">
//                                     <div className="container">
//                                         <h1 className="strong">Iniciar Sesión</h1>
//                                         <ErrorBoundary>
//                                             <LoginForm
//                                                 dataForm={reciveDataLogin}
//                                                 warningMessage={dataLogin.errorMessage}
//                                                 urlRedirect={dataLogin.redir}
//                                                 responseFacebook={reciveDataFacebook}
//                                                 isMobile={isMobile}
//                                             />
//                                         </ErrorBoundary>
//                                     </div>
//                                 </section>
//                             }
//                         </>
//                     :
//                         <>
//                             <ErrorBoundary>
//                                 <ErrorType
//                                     codeStatus={500}
//                                     errorText={""}
//                                 />
//                             </ErrorBoundary>
//                         </>
//                 }

//             </main>
//         </>
//     )
// }